const shopifyGidFromProductId = (productId: string | number) => {
    return `gid://shopify/Product/${productId}`;
};

const shopifyIdFromGid = (gid: string) => {
    return gid.split('/').pop();
};

export { shopifyGidFromProductId, shopifyIdFromGid };
